<template>
  <div class="tangtang-page min-h-screen pb-[236px] md:min-h-[calc(100vh-64px)] lg:pb-0">
    <div class="home mx-auto grid w-[94%] grid-cols-12 gap-4 px-2 py-4 sm:px-4">
      <!-- 좌: 전체 채팅 (1) -->
      <div class="hidden lg:block col-span-12 lg:col-span-3">
        <div
          class="tangtang-panel h-[calc(100svh-140px)] md:h-[calc(100vh-64px-32px)] flex flex-col"
        >
          <div class="flex-1 overflow-hidden p-2">
            <ChatView class="" />
          </div>
        </div>
      </div>
      <!-- 중: 스트리밍 (1) -->
      <div class="col-span-12 lg:col-span-3">
        <div
          class="tangtang-panel flex min-h-[60vh] flex-col p-2 sm:min-h-[68vh] sm:p-3 md:h-[calc(100vh-64px-32px)] lg:h-[calc(100svh-140px)] lg:min-h-0"
        >
          <div
            class="flex-1 h-full min-h-0 flex items-center justify-center overflow-hidden p-0 relative"
          >
            <div v-if="youtubeEmbedUrl" class="youtube-live-shell">
              <iframe
                :src="youtubeEmbedUrl"
                title="YouTube Live"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                class="youtube-live-frame"
              ></iframe>
              <div class="youtube-live-shield" aria-hidden="true"></div>
            </div>
            <div
              v-else
              class="absolute inset-0 flex flex-col items-center justify-center rounded-[28px] border-[10px] border-[#080f1a] bg-black/35 px-6 text-center shadow-[0_0_0_1px_rgba(30,200,255,0.28),0_28px_80px_rgba(0,0,0,0.55)]"
            >
              <strong class="mb-3 text-xl font-black text-[#1ec8ff]">YouTube Live</strong>
              <span class="text-sm font-semibold text-[#9eb6c8]">
                frontend/.env에 VUE_APP_YOUTUBE_EMBED_URL을 설정해주세요.
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 우: 게임 결과 (2) -->
      <div class="col-span-12 lg:col-span-6">
        <div
          class="tangtang-panel flex min-h-[520px] flex-col md:h-[calc(100vh-64px-32px)] lg:h-[calc(100svh-140px)] lg:min-h-0"
        >
          <!-- 상: 오늘 현황판 (auto height, no scroll) -->
          <div class="p-3 sm:p-4">
            <div class="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
              <div class="text-base font-extrabold text-white md:text-lg">
                탱탱볼 통계 · {{ todayLabel }}
              </div>
              <div
                class="w-fit rounded-full bg-[#1ec8ff] px-3 py-1.5 text-sm font-black text-[#111a27] md:px-4 md:py-2 md:text-base"
              >
                {{ displayTodayStats.totalCount }}회
              </div>
            </div>
            <!-- 0~9 카운트 -->
            <div class="mb-4 grid grid-cols-5 gap-2 sm:grid-cols-10">
              <div v-for="n in 10" :key="n" class="stat-card rounded-2xl p-3 text-center sm:p-2">
                <div class="text-lg font-extrabold text-white sm:text-2xl md:text-3xl">
                  {{ n - 1 }}
                </div>
                <div class="border-t border-white/10 my-2"></div>
                <div class="text-lg font-extrabold text-[#1ec8ff] sm:text-2xl md:text-3xl">
                  {{ displayTodayStats.digitCounts[n - 1] || 0 }}
                </div>
                <div class="mt-1 h-1.5 bg-black/30 rounded">
                  <div
                    class="h-1.5 bg-[#1ec8ff] rounded"
                    :style="{ width: digitPercent(n - 1) + '%' }"
                  ></div>
                </div>
                <div class="mt-1 text-[11px] font-semibold text-[#9eb6c8] sm:text-xs md:text-sm">
                  {{ digitPercent(n - 1) }}%
                </div>
              </div>
            </div>
            <!-- 홀/짝, 좌/우 합계 -->
            <div class="grid grid-cols-2 gap-3 md:grid-cols-4">
              <div class="stat-card rounded-2xl p-3 text-center">
                <div class="text-xl md:text-2xl font-extrabold text-white">홀</div>
                <div class="border-t border-white/10 my-2"></div>
                <div class="text-2xl md:text-3xl font-extrabold text-sky-400">
                  {{ displayTodayStats.oddCount }}
                  <span class="text-xs md:text-sm font-semibold text-[#9eb6c8] ml-1">
                    ({{ oddPercent }}%)
                  </span>
                </div>
              </div>
              <div class="stat-card rounded-2xl p-3 text-center">
                <div class="text-xl md:text-2xl font-extrabold text-white">짝</div>
                <div class="border-t border-white/10 my-2"></div>
                <div class="text-2xl md:text-3xl font-extrabold text-rose-400">
                  {{ displayTodayStats.evenCount }}
                  <span class="text-xs md:text-sm font-semibold text-[#9eb6c8] ml-1">
                    ({{ evenPercent }}%)
                  </span>
                </div>
              </div>
              <div class="stat-card rounded-2xl p-3 text-center">
                <div class="text-xl md:text-2xl font-extrabold text-white">좌</div>
                <div class="border-t border-white/10 my-2"></div>
                <div class="text-2xl md:text-3xl font-extrabold text-cyan-300">
                  {{ displayTodayStats.leftCount }}
                  <span class="text-xs md:text-sm font-semibold text-[#9eb6c8] ml-1">
                    ({{ leftPercent }}%)
                  </span>
                </div>
              </div>
              <div class="stat-card rounded-2xl p-3 text-center">
                <div class="text-xl md:text-2xl font-extrabold text-white">우</div>
                <div class="border-t border-white/10 my-2"></div>
                <div class="text-2xl md:text-3xl font-extrabold text-sky-300">
                  {{ displayTodayStats.rightCount }}
                  <span class="text-xs md:text-sm font-semibold text-[#9eb6c8] ml-1">
                    ({{ rightPercent }}%)
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- 하: 결과 테이블 (fills remaining, scroll here) -->
          <div class="results-scroll relative flex-1 overflow-auto">
            <table class="min-w-[560px] w-full text-center text-xs text-slate-200 sm:min-w-0">
              <thead class="text-xs uppercase bg-[#142235] text-slate-100 sticky top-0 z-10">
                <tr>
                  <th
                    scope="col"
                    class="sticky top-0 z-10 bg-[#142235] px-3 py-4 text-center sm:px-6 sm:py-6"
                  >
                    회차
                  </th>
                  <th
                    scope="col"
                    class="sticky top-0 z-10 bg-[#142235] px-3 py-4 text-center sm:px-6 sm:py-6"
                  >
                    시간
                  </th>
                  <th
                    scope="col"
                    class="sticky top-0 z-10 bg-[#142235] px-3 py-4 text-center sm:px-6 sm:py-6"
                  >
                    결과
                  </th>
                  <th
                    scope="col"
                    class="sticky top-0 z-10 bg-[#142235] px-3 py-4 text-center sm:px-6 sm:py-6"
                  >
                    홀/짝
                  </th>
                  <th
                    scope="col"
                    class="sticky top-0 z-10 bg-[#142235] px-3 py-4 text-center sm:px-6 sm:py-6"
                  >
                    좌/우
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="g in gameResults.slice(0, 20)"
                  :key="g.round"
                  class="border-b border-white/10 hover:bg-white/[0.04]"
                >
                  <td
                    scope="row"
                    class="px-3 py-3 font-medium whitespace-nowrap text-center sm:px-6 sm:py-4"
                  >
                    <span class="mr-2">{{ g.round }} 회차</span>
                  </td>
                  <td class="px-3 py-3 text-center sm:px-6 sm:py-4">
                    {{ (g.created_at || '').toString().slice(11, 19) }}
                  </td>
                  <td class="px-3 py-3 text-center sm:px-6 sm:py-4">{{ g.value }}</td>
                  <td
                    class="px-3 py-3 text-center sm:px-6 sm:py-4"
                    :class="Number(g.value) % 2 === 1 ? 'text-sky-400' : 'text-rose-400'"
                  >
                    {{ Number(g.value) % 2 === 1 ? '홀' : '짝' }}
                  </td>
                  <td
                    class="px-3 py-3 text-center sm:px-6 sm:py-4"
                    :class="Number(g.value) <= 4 ? 'text-cyan-300' : 'text-sky-300'"
                  >
                    {{ Number(g.value) <= 4 ? '좌' : '우' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="fixed inset-x-0 bottom-0 z-40 lg:hidden">
      <div
        class="rounded-t-[26px] border-x border-t border-white/10 bg-[#111a27]/95 shadow-[0_-12px_40px_rgba(0,0,0,0.42)] backdrop-blur-xl"
      >
        <div class="h-[220px] overflow-hidden">
          <ChatView class="h-full" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import ChatView from './Chat/ChatView.vue';

function buildYoutubeEmbedUrl(value) {
  if (!value) return '';

  try {
    const url = new URL(value);
    const hostname = url.hostname.replace(/^www\./, '').toLowerCase();
    const isYoutubeHost =
      hostname === 'youtube.com' || hostname === 'youtu.be' || hostname === 'youtube-nocookie.com';
    if (!isYoutubeHost) return '';
    const videoId = url.hostname.includes('youtu.be')
      ? url.pathname.replace('/', '')
      : url.searchParams.get('v');

    if (videoId && !url.pathname.includes('/embed/')) {
      url.hostname = 'www.youtube.com';
      url.pathname = `/embed/${videoId}`;
      url.search = '';
    }

    url.searchParams.set('autoplay', url.searchParams.get('autoplay') || '1');
    url.searchParams.set('mute', url.searchParams.get('mute') || '1');
    url.searchParams.set('controls', '0');
    url.searchParams.set('modestbranding', '1');
    url.searchParams.set('disablekb', '1');
    url.searchParams.set('playsinline', '1');
    url.searchParams.set('rel', '0');
    return url.toString();
  } catch (_) {
    return '';
  }
}

export default {
  components: { ChatView },
  name: 'HomeView',
  async mounted() {
    try {
      const base = process.env.VUE_APP_API_URL || 'http://localhost:3000';
      const { data } = await axios.get(`${base}/game/results/today?limit=500`);
      const results = data && data.results ? data.results : [];
      this.$store.commit('mountGame', results);
      // 소켓 리스너 등록
      this.$store.commit('onMessage');
      // 오늘 통계 로드 (DB 전체 기준)
      const statsRes = await axios.get(`${base}/game/stats/today`);
      if (statsRes && statsRes.data) {
        this.todayStats = {
          digitCounts: statsRes.data.digitCounts || Array(10).fill(0),
          oddCount: statsRes.data.oddCount || 0,
          evenCount: statsRes.data.evenCount || 0,
          leftCount: statsRes.data.leftCount || 0,
          rightCount: statsRes.data.rightCount || 0,
          totalCount: statsRes.data.totalCount || 0,
        };
      }
      // 실시간 결과가 들어오면 현황판에 즉시 반영
      if (this.$store.state.socket) {
        // 이전 핸들러 해제 후 등록 (중복 방지)
        if (this._statsHandler) {
          this.$store.state.socket.off('game result', this._statsHandler);
        }
        this._statsHandler = (res) => {
          if (!res || typeof res.value === 'undefined') return;
          const created = res.created_at ? new Date(res.created_at) : new Date();
          const now = new Date();
          if (
            created.getFullYear() !== now.getFullYear() ||
            created.getMonth() !== now.getMonth() ||
            created.getDate() !== now.getDate()
          ) {
            return; // 오늘 데이터만 반영
          }
          // todayStats가 없으면 무시 (초기 로딩 전) — 이후 새 이벤트는 반영됨
          if (!this.todayStats) return;
          const v = Number(res.value);
          if (!Number.isNaN(v) && v >= 0 && v <= 9) {
            this.todayStats.totalCount += 1;
            this.todayStats.digitCounts[v] = (this.todayStats.digitCounts[v] || 0) + 1;
            if (v % 2 === 1) this.todayStats.oddCount += 1;
            else this.todayStats.evenCount += 1;
            if (v <= 4) this.todayStats.leftCount += 1;
            else this.todayStats.rightCount += 1;
          }
        };
        this.$store.state.socket.on('game result', this._statsHandler);
      }
    } catch (e) {
      console.error('초기 게임 결과 로드 실패', e);
    }
  },
  beforeUnmount() {
    if (this.$store?.state?.socket && this._statsHandler) {
      this.$store.state.socket.off('game result', this._statsHandler);
    }
  },
  methods: {
    betting() {
      this.$store.commit('bet');
    },
    percentSafe(numerator, denominator) {
      const d = Number(denominator) || 0;
      if (d <= 0) return 0;
      const v = Math.round((Number(numerator || 0) / d) * 100);
      return isNaN(v) ? 0 : v;
    },
    digitPercent(idx) {
      const counts = this.displayTodayStats.digitCounts || [];
      const total = this.displayTodayStats.totalCount || 0;
      return this.percentSafe(counts[idx] || 0, total);
    },
  },
  computed: {
    gameResults() {
      return this.$store.state.gameResults;
    },
    todayLabel() {
      const t = new Date();
      return t.toLocaleDateString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit' });
    },
    fallbackTodayStats() {
      const list = this.gameResults || [];
      const today = new Date();
      const y = today.getFullYear();
      const m = today.getMonth();
      const d = today.getDate();
      const digitCounts = Array(10).fill(0);
      let oddCount = 0;
      let evenCount = 0;
      let leftCount = 0;
      let rightCount = 0;
      let totalCount = 0;
      for (const g of list) {
        const t = g && g.created_at ? new Date(g.created_at) : null;
        if (!t || t.getFullYear() !== y || t.getMonth() !== m || t.getDate() !== d) continue;
        totalCount++;
        const v = Number(g.value);
        if (!Number.isNaN(v) && v >= 0 && v <= 9) {
          digitCounts[v] += 1;
          if (v % 2 === 1) oddCount += 1;
          else evenCount += 1;
          if (v <= 4) leftCount += 1;
          else rightCount += 1;
        }
      }
      return { digitCounts, oddCount, evenCount, leftCount, rightCount, totalCount };
    },
    displayTodayStats() {
      return this.todayStats || this.fallbackTodayStats;
    },
    oddPercent() {
      return this.percentSafe(this.displayTodayStats?.oddCount, this.displayTodayStats?.totalCount);
    },
    evenPercent() {
      return this.percentSafe(
        this.displayTodayStats?.evenCount,
        this.displayTodayStats?.totalCount,
      );
    },
    leftPercent() {
      return this.percentSafe(
        this.displayTodayStats?.leftCount,
        this.displayTodayStats?.totalCount,
      );
    },
    rightPercent() {
      return this.percentSafe(
        this.displayTodayStats?.rightCount,
        this.displayTodayStats?.totalCount,
      );
    },
  },
  data() {
    return {
      betList: [],
      betPrice: 0,
      youtubeEmbedUrl: buildYoutubeEmbedUrl(process.env.VUE_APP_YOUTUBE_EMBED_URL),
      todayStats: null,
    };
  },
  watch: {
    betList: {
      handler(val) {
        console.log(val);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.tangtang-page {
  background:
    radial-gradient(circle at 12% 0%, rgba(30, 200, 255, 0.18), transparent 34rem),
    radial-gradient(circle at 100% 18%, rgba(17, 93, 70, 0.72), transparent 38rem),
    linear-gradient(135deg, #080f1a 0%, #111a27 48%, #10233a 100%);
  color: #f5fff8;
}

.chat-open-button {
  background: #1ec8ff;
  color: #111a27;
}

.tangtang-panel,
.stat-card {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(13, 25, 40, 0.86);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(18px);
}

.tangtang-panel {
  border-radius: 24px;
  overflow: hidden;
}

.stat-card {
  background: linear-gradient(145deg, rgba(30, 200, 255, 0.13), rgba(12, 33, 51, 0.82)), #111a27;
}

.youtube-live-shell {
  position: absolute;
  inset: 0;
  border-radius: 8px;
  box-sizing: border-box;
  overflow: hidden;
  background: #080f1a;
  box-shadow:
    0 0 0 1px rgba(30, 200, 255, 0.28),
    0 28px 80px rgba(0, 0, 0, 0.55);
}

.youtube-live-frame {
  position: absolute;
  top: 50%;
  left: 50%;
  width: calc(100vh - 136px);
  height: calc(100% - 72px);
  min-width: calc(100vh - 136px);
  min-height: calc(100% - 72px);
  border: 0;
  background: #000;
  transform: translate(-50%, -50%) rotate(90deg);
  transform-origin: center;
}

.youtube-live-shield {
  position: absolute;
  inset: 0;
  z-index: 2;
  border-radius: 8px;
  background: transparent;
}

td {
  font-weight: bold;
  font-size: 0.875rem;
}
tr th {
  font-size: 0.875rem;
}
/* 게임 결과 스크롤바 테마 */
.results-scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.results-scroll::-webkit-scrollbar-track {
  background: #111a27;
}
.results-scroll::-webkit-scrollbar-thumb {
  background: rgba(30, 200, 255, 0.58);
  border-radius: 999px;
}
.results-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(30, 200, 255, 0.86);
}
.results-scroll {
  scrollbar-color: rgba(30, 200, 255, 0.58) #111a27;
  scrollbar-width: thin;
}

@media (min-width: 640px) {
  td,
  tr th {
    font-size: 1rem;
  }
}

@media (max-width: 1023px) {
  .youtube-live-frame {
    width: calc(100svh - 12px);
    height: calc(100% - 8px);
    min-width: calc(100svh - 12px);
    min-height: calc(100% - 8px);
  }
}
</style>
